import { LogsApi } from '~/api/logs';

class LogsServiceClass {
  public async downloadLogs() {
    await LogsApi.downloadLogs();
  }
}
export const LogsService = new LogsServiceClass();
